import { render } from "./Modal.vue?vue&type=template&id=22a18b94&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-22a18b94"

export default script